"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constants = {
    addressSuffix: "L",
    primaryTokenTicker: "LSK",
    primaryTokenName: "Lisk",
    primaryTokenFractionalDigits: 8,
    transactionSerializationOptions: {
        maxMemoLength: 64,
    },
};
//# sourceMappingURL=constants.js.map